import "./TabsPanel.scss";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import ClientInfo from "components/ClientInfo/ClientInfo";
import PersonalOrders from "components/PersonalOrders/PersonalOrders";
import AccountSettings from "components/AccountSettings/AccountSettings";
import PersonalOrdersMobile from "components/PersonalOrdersMobile/PersonalOrdersMobile";
import BusinessInfo from "components/BusinessInfo/BusinessInfo";
import { useAppSelector } from "store";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
  style?: React.CSSProperties;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
    {...other}
  >
    {value === index && <div>{children}</div>}
  </div>
);

const TabsPanel = () => {
  const [value, setValue] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:1024px)");
  const { orders } = useAppSelector((state) => state.cabinet);
  const type = localStorage.getItem("type") || sessionStorage.getItem("type");

  const isBusiness = type === "BUSINESS";
  const personalOrdersIndex = isBusiness ? 2 : 1;
  const settingsIndex = isBusiness ? 3 : 2;

  const tabMap = isBusiness
    ? ["profile", "business", "orders", "settings"]
    : ["profile", "orders", "settings"];

  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(`#${tabMap[newValue]}`);
  };

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (!hash) {
      navigate(`#${tabMap[0]}`, { replace: true });
    } else {
      const index = tabMap.indexOf(hash);
      if (index !== -1 && index !== value) {
        setValue(index);
      }
    }
  }, [location.hash]);

  return (
    <div className="tabs-container">
      <Tabs
        orientation={isSmallScreen ? "horizontal" : "vertical"}
        variant="scrollable"
        className="tabs-panel"
        value={value}
        onChange={handleChange}
        sx={{
          borderRight: isSmallScreen ? 0 : 1,
          borderBottom: isSmallScreen ? 1 : 0,
          borderColor: "divider",
        }}
      >
        <Tab label="Profile info" id="tab-0" aria-controls="tabpanel-0" />
        {type === "BUSINESS" && (
          <Tab label="Business info" id="tab-3" aria-controls="tabpanel-1" />
        )}
        <Tab
          label="Personal orders"
          id={`tab-${personalOrdersIndex}`}
          aria-controls={`tabpanel-${personalOrdersIndex}`}
        />
        <Tab
          label="Settings"
          id={`tab-${settingsIndex}`}
          aria-controls={`tabpanel-${settingsIndex}`}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <ClientInfo />
      </TabPanel>
      {type === "BUSINESS" && (
        <TabPanel value={value} index={1}>
          <BusinessInfo />
        </TabPanel>
      )}
      <TabPanel
        value={value}
        index={personalOrdersIndex}
        style={{ width: "100%" }}
      >
        {isSmallScreen ? (
          <PersonalOrdersMobile orders={orders} />
        ) : (
          <PersonalOrders orders={orders} />
        )}
      </TabPanel>
      <TabPanel value={value} index={settingsIndex}>
        <AccountSettings />
      </TabPanel>
    </div>
  );
};

export default TabsPanel;
